var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eraser"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.9995 12.9995L10.9995 5.99955M20.9995 20.9995H7.99955M10.9368 20.0623L19.6054 11.3937C20.7935 10.2056 21.3875 9.61158 21.6101 8.9266C21.8058 8.32407 21.8058 7.67503 21.6101 7.0725C21.3875 6.38751 20.7935 5.79349 19.6054 4.60543L19.3937 4.39366C18.2056 3.20561 17.6116 2.61158 16.9266 2.38902C16.3241 2.19324 15.675 2.19324 15.0725 2.38902C14.3875 2.61158 13.7935 3.20561 12.6054 4.39366L4.39366 12.6054C3.20561 13.7935 2.61158 14.3875 2.38902 15.0725C2.19324 15.675 2.19324 16.3241 2.38902 16.9266C2.61158 17.6116 3.20561 18.2056 4.39366 19.3937L5.06229 20.0623C5.40819 20.4082 5.58114 20.5811 5.78298 20.7048C5.96192 20.8145 6.15701 20.8953 6.36108 20.9443C6.59126 20.9995 6.83585 20.9995 7.32503 20.9995H8.67406C9.16324 20.9995 9.40784 20.9995 9.63801 20.9443C9.84208 20.8953 10.0372 20.8145 10.2161 20.7048C10.418 20.5811 10.5909 20.4082 10.9368 20.0623Z",
    stroke: "#0F3D5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.c25b2174d7e4713c3f83f3e1ab0a0bf5.svg";
export { ForwardRef as ReactComponent };